import * as _ from 'lodash';

import * as Model from '../../models/models';
import * as Repositories from '../../repositories/repositories';
import { PaymentSearchByStatementResult, PaymentSearchByStatementViewModel } from './paymentSearchByStatement.viewmodel';


export class PaymentSearchByStatementGateway {

    static $inject = ['$q', '$log', 'policyholderRepository','billingStatementRepository','paymentRepository' ];
    constructor(private $q: ng.IQService,
        private $log: ng.ILogService,
        private policyholderRepository: Repositories.PolicyholderRepository,
        private billingStatementRepository: Repositories.BillingStatementRepository,
        private paymentRepository: Repositories.PaymentRepository
    ) { }

    public loadPaymentSearchByStatementViewModel = (searchCriteriaModel: Model.IPaymentSearchByStatementCriteria): ng.IPromise<PaymentSearchByStatementViewModel> => {

        searchCriteriaModel.eventTimeFromLocal = this.convertUtcTimeToLocalTime(searchCriteriaModel.eventTimeFromUtc);
        searchCriteriaModel.eventTimeToLocal = this.convertUtcTimeToLocalTime(searchCriteriaModel.eventTimeToUtc);

        if(searchCriteriaModel.organizationName)
        {
           return this.loadSearchResultsWithOrganizationName(searchCriteriaModel);
        }
        else
        {
         return this.loadSearchResultsWithOutOrganizationName(searchCriteriaModel);
        }

    }

    private loadSearchResultsWithOrganizationName = (searchCriteriaModel: Model.IPaymentSearchByStatementCriteria): ng.IPromise<PaymentSearchByStatementViewModel> => {

        let searchViewModel = new PaymentSearchByStatementViewModel();

        return this.getPolicyholderByOrganizationName(searchCriteriaModel.organizationName)
            .then((policyholders: Array<Model.IPolicyholder>) => {

                searchViewModel.policyholders = policyholders;
                let billingStatementLogSearchCriteria = new Model.BillingStatementLogSearchCriteria();
                billingStatementLogSearchCriteria.billingAccountNumbers = _.map(policyholders,'billingAccountNumber')as Array<string>;
                billingStatementLogSearchCriteria.eventTimeFromLocal = searchCriteriaModel.eventTimeFromLocal;
                billingStatementLogSearchCriteria.eventTimeToLocal = searchCriteriaModel.eventTimeToLocal;
                return this.getBillingStatementLogs(billingStatementLogSearchCriteria)
            })
            .then((billingStatementLogs: Array<Model.IBillingStatement>) => {

                searchViewModel.billingstatementlogs = billingStatementLogs;
            return this.loadSearchResults(searchViewModel);
            })


    }

    private loadSearchResultsWithOutOrganizationName = (searchCriteriaModel: Model.IPaymentSearchByStatementCriteria): ng.IPromise<PaymentSearchByStatementViewModel> => {

        let searchViewModel = new PaymentSearchByStatementViewModel();

        let billingStatementLogSearchCriteria = new Model.BillingStatementLogSearchCriteria();
            billingStatementLogSearchCriteria.eventTimeFromLocal = searchCriteriaModel.eventTimeFromLocal;
            billingStatementLogSearchCriteria.eventTimeToLocal = searchCriteriaModel.eventTimeToLocal;

        return this.getBillingStatementLogs(billingStatementLogSearchCriteria)
            .then((billingStatementLogs: Array<Model.IBillingStatement>) => {

                searchViewModel.billingstatementlogs = billingStatementLogs;
                let policyholderSearchCriteria = new Model.PolicyholderSearchCriteria();
                policyholderSearchCriteria.billingAccountNumbers = _.map(billingStatementLogs, 'billingAccountNumber') as Array<string>;
                return this.getPolicyholderByBillingAccountNumber(policyholderSearchCriteria);

            })
            .then((policyholders:Array<Model.IPolicyholder>)=>{

                searchViewModel.policyholders = policyholders;
                return this.loadSearchResults(searchViewModel);
            })

    }

    private loadSearchResults = (searchViewModel:PaymentSearchByStatementViewModel):ng.IPromise<PaymentSearchByStatementViewModel> =>{

        let billingStatementLogPaymentResponseSearchCriteria = new Model.BillingStatementLogPaymentResponseSearchCriteria();
        billingStatementLogPaymentResponseSearchCriteria.billingStatementLogIds = _.map(searchViewModel.billingstatementlogs,'id') as Array<string>;

        return this.getBillingStatementLogPaymentResponses(billingStatementLogPaymentResponseSearchCriteria)
            .then((billingStatementLogPaymentResponses: Array<Model.IBillingStatementLogPaymentResponse>) => {

                searchViewModel.billingstatementlogpaymentresponses = billingStatementLogPaymentResponses;
                let paymentresponseSearchCriteria = new Model.PaymentResponseSearchCriteria();
                paymentresponseSearchCriteria.paymentResponseIds = _.map(billingStatementLogPaymentResponses,'paymentResponseId') as Array<string>
                return this.getPaymentResponses(paymentresponseSearchCriteria);
            })
            .then((paymentResponses: Array<Model.IPaymentResponse>) => {
                searchViewModel.paymentResponses = paymentResponses;
                let searchCriteria = new Model.PaymentSearchByMerchantReferenceCriteria();
                searchCriteria.merchantReferenceCodes= _.map(paymentResponses,'merchantReferenceCode') as Array<string>
                return this.getPaymentRequests(searchCriteria);
            })
            .then((paymentRequests: Array<Model.IPaymentRequest>) => {
                searchViewModel.paymentRequests = paymentRequests;
                return searchViewModel;
            })
            .then((paymentSearchViewModel: PaymentSearchByStatementViewModel) => {
            return this.createSearchResults(paymentSearchViewModel);
            })
            .catch((err) => {
                console.log(err);
                return searchViewModel;
            });

    }

    private getPolicyholderByOrganizationName = (organizationName:string): ng.IPromise<Array<Model.IPolicyholder>> => {
        return this.policyholderRepository.getPolicyholdersByOrganziationName(organizationName)
            .then((policyholders: Array<Model.IPolicyholder>) => {
                return policyholders;
            });
    }

    private getPolicyholderByBillingAccountNumber = (searchCriteria:Model.IPolicyholderSearchCriteria): ng.IPromise<Array<Model.IPolicyholder>> => {
        return this.policyholderRepository.PolicyholderSearch(searchCriteria)
            .then((policyholders: Array<Model.IPolicyholder>) => {
                return policyholders;
            });
    }

    private getBillingStatementLogs = (searchCriteria: Model.IBillingStatementLogSearchCriteria): ng.IPromise<Array<Model.IBillingStatement>> => {
        return this.billingStatementRepository.billingStatementLogSearchAsync(searchCriteria)
            .then((billingStatements: Array<Model.IBillingStatement>) => {
                return billingStatements;
            });
    }

    private getBillingStatementLogPaymentResponses = (searchCriteria: Model.IBillingStatementLogPaymentResponseSearchCriteria): ng.IPromise<Array<Model.IBillingStatementLogPaymentResponse>> => {
        return this.billingStatementRepository.billingStatementLogPaymentResponseSearchAsync(searchCriteria)
        .then((billingStatementLogPaymentResponses: Array<Model.IBillingStatementLogPaymentResponse>) => {
            return billingStatementLogPaymentResponses;
        });
    }

    private getPaymentResponses = (searchCriteria: Model.IPaymentResponseSearchCriteria): ng.IPromise<Array<Model.IPaymentResponse>> => {
        return this.paymentRepository.paymentResponseSearchAsync(searchCriteria)
        .then((paymentResponses: Array<Model.IPaymentResponse>) => {
            return paymentResponses;
        });
    }

    private getPaymentRequests = (searchCriteria: Model.IPaymentSearchByMerchantReferenceCriteria): ng.IPromise<Array<Model.IPaymentRequest>> => {
        return this.paymentRepository.paymentRequestSearchByMerchantReferenceAsync(searchCriteria)
        .then((paymentRequests: Array<Model.IPaymentRequest>) => {
            return paymentRequests;
        });
    }

    private createSearchResults = (searchViewModel: PaymentSearchByStatementViewModel): PaymentSearchByStatementViewModel => {

        let searchResults = new Array<PaymentSearchByStatementResult>();

        //map billingstatementlog data to new search result array
        _.forEach(searchViewModel.billingstatementlogs, (billingstatementlog:Model.IBillingStatement) => {
            let searchResult = new PaymentSearchByStatementResult();
            searchResult.billedAndUnpaidBalance = billingstatementlog.billedAndUnpaidBalance
            searchResult.currentDueDate = billingstatementlog.currentDueDate
            searchResult.pastDueBalance = billingstatementlog.pastDueBalance;
            searchResult.billingAccountNumber = billingstatementlog.billingAccountNumber;
            searchResult.billingStatementLogid = billingstatementlog.id;

            //map organization
            _.forEach(searchViewModel.policyholders,(policyholder: Model.IPolicyholder) => {
                if (billingstatementlog.billingAccountNumber === policyholder.billingAccountNumber) {
                    searchResult.organizationName = policyholder.name;
                    searchResult.autoPay = policyholder.autopay;

                }
            });

            //map payment request and payment response
            _.forEach(searchViewModel.billingstatementlogpaymentresponses,(bslpr: Model.IBillingStatementLogPaymentResponse) => {

                if(billingstatementlog.id === bslpr.billingStatementLogId )
                {
                    _.forEach(searchViewModel.paymentResponses,(paymentResponse: Model.IPaymentResponse) => {

                        if(bslpr.paymentResponseId === paymentResponse.id )
                        {
                            searchResult.decisionTypeCode = paymentResponse.decisionTypeCode;
                            searchResult.reasonCode = paymentResponse.reasonCode;
                            searchResult.merchantReferenceCode = paymentResponse.merchantReferenceCode;

                            _.forEach(searchViewModel.paymentRequests,(paymentRequest: Model.IPaymentRequest) => {
                                if (paymentResponse.merchantReferenceCode === paymentRequest.merchantReferenceCode) {
                                    searchResult.paymentAmount = paymentRequest.amount;
                                    searchResult.paymentType = paymentRequest.paymentTokenType;
                                }
                            });
                        }

                    });
                }
            });

            searchResults.push(searchResult);
        });


        searchViewModel.searchResults = searchResults;

        return searchViewModel;

    }

    private convertUtcTimeToLocalTime = (date: Date): Date => {

        //The BillingStatementLog.CurrentDueDate is a NON Utc DateTime but it is stored in a Date2 field in the database.
        //Therefore the Utc conversion does not need to be applied. This is just a reminder
        return date;

    }
}